export default __webpack_public_path__ + "static/media/Parent_Illustrations-02.3595952c.svg";